import { Component, Input, ViewEncapsulation, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'sb-shadow-dom',
    template: `<div [innerHtml]="trustedContent"></div>`,
    encapsulation: ViewEncapsulation.ShadowDom
})
export class ShadowDomComponent implements AfterViewInit, OnChanges {
  @Input() trustedHtml: string;
  trustedContent: SafeHtml = '';
  
  constructor(public ds: DomSanitizer) { }

  ngAfterViewInit() {
    this.updateContent();
  }
  
  // for using in AngularJS component
  ngOnChanges(changes: SimpleChanges) {
    if (changes['trustedHtml']) {
      this.updateContent();
    }
  }

  private updateContent() {
    if (this.trustedHtml) {
      this.trustedContent = this.ds.bypassSecurityTrustHtml(this.trustedHtml);
    }
  }
}
